import { combineReducers } from "redux";
import themeReducer from "./themeReducer";
import modalReducer from "./modalReducer";

const  reducers = combineReducers({
    theme: themeReducer,
    modal: modalReducer,
})

export default reducers;